module.exports = __webpack_public_path__ + "files/ef04c35be022ea1cb51e1da597902b0e.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-76x76.png
// module id = 568
// module chunks = 60